import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Timetable from "Administrator/routes/Timetable";
export default store => ({
  path: "timetable-configuration",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "course-timetable-configuration" */ "./components"
        ),
        import(
          /* webpackChunkName: "course-timetable-configuration" */ "./modules/TimetableConfigurationModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "timetableConfiguration",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Timetable(store)],
});
